import { render, staticRenderFns } from "./EditInventoryItemModal.vue?vue&type=template&id=2ada6604&scoped=true&class=fill-height&"
import script from "./EditInventoryItemModal.vue?vue&type=script&lang=ts&"
export * from "./EditInventoryItemModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditInventoryItemModal.vue?vue&type=style&index=0&id=2ada6604&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada6604",
  null
  
)

export default component.exports